(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wiepa-adventskalender-vorbestellung"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents) => new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);

    const init = (root) => {
      if (!root || root.dataset.preorderReady === 'true') return;
      root.dataset.preorderReady = 'true';

      const quantities = [...root.querySelectorAll('[data-preorder-quantity]')];
      const totalOutput = root.querySelector('[data-preorder-total]');
      const totalField = root.querySelector('[data-preorder-total-field]');
      const summaryField = root.querySelector('[data-preorder-summary]');
      const form = root.querySelector('form');
      const error = root.querySelector('[data-preorder-error]');

      const update = () => {
        let total = 0;
        const selections = [];

        quantities.forEach((input) => {
          const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
          const price = Number.parseInt(input.dataset.priceCents, 10) || 0;
          input.value = quantity;
          total += quantity * price;

          if (quantity > 0) {
            selections.push(`${input.dataset.productTitle} | SKU: ${input.dataset.productSku || 'keine'} | Menge: ${quantity} | Richtpreis gesamt: ${formatMoney(quantity * price)}`);
          }
        });

        const formatted = formatMoney(total);
        if (totalOutput) totalOutput.textContent = formatted;
        if (totalField) totalField.value = formatted;
        if (summaryField) summaryField.value = selections.join('\n');
        if (error && selections.length > 0) error.hidden = true;
      };

      root.addEventListener('click', (event) => {
        const minus = event.target.closest('[data-qty-minus]');
        const plus = event.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;

        const card = event.target.closest('[data-product-card]');
        const input = card?.querySelector('[data-preorder-quantity]');
        if (!input || input.disabled) return;

        const current = Number.parseInt(input.value, 10) || 0;
        input.value = minus ? Math.max(0, current - 1) : current + 1;
        update();
      });

      quantities.forEach((input) => input.addEventListener('input', update));

      form?.addEventListener('submit', (event) => {
        update();
        const hasSelection = quantities.some((input) => (Number.parseInt(input.value, 10) || 0) > 0);
        if (!hasSelection) {
          event.preventDefault();
          if (error) {
            error.hidden = false;
            error.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });

      update();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-wiepa-preorder]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
